import { useState } from 'react'
import { useMap } from 'react-map-gl'
import textos from '../assets/textos.json'

const Llegenda = ({ lang }) => {
	const { mapa_dana } = useMap()

	const [capaActiva, setCapaActiva] = useState(false)

	const handleClick = (id) => {
		const mapa = mapa_dana?.getMap()
		if (!mapa) return

		const edificisVisibles =
			mapa.getLayoutProperty('dana-edificis-afectats', 'visibility') ===
				'visible' ||
			mapa.getLayoutProperty('dana-edificis-afectats', 'visibility') ===
				undefined

		const filtersMap = mapa.getFilter('dana-edificis-afectats')

		if (id === capaActiva) {
			mapa.setFilter('dana-edificis-afectats', null)
			mapa.setLayoutProperty('dana-edificis-afectats', 'visibility', 'visible')
			setCapaActiva(false)
		} else {
			setCapaActiva(id)
			if (id === 'Flooded') {
				if (filtersMap) {
					mapa.setFilter('dana-edificis-afectats', null)
				}
				mapa.setLayoutProperty(
					'dana-edificis-afectats',
					'visibility',
					edificisVisibles ? 'none' : 'visible'
				)
			} else {
				mapa.setLayoutProperty(
					'dana-edificis-afectats',
					'visibility',
					'visible'
				)
				mapa.setFilter('dana-edificis-afectats', ['==', 'damage_gra', id])
			}
		}
	}

	return (
		<nav className='llegenda'>
			<p>
				<span>Filtra:</span>
				<span className='font'>{textos[lang].font}</span>
			</p>
			<ul>
				{textos[lang].llegenda.map((item) => (
					<li
						key={item.id}
						onClick={() => handleClick(item.id)}
						style={{
							opacity:
								capaActiva === item.id || capaActiva === false ? '1' : '0.5',
						}}
					>
						<span style={{ backgroundColor: item.color }}></span>
						{item.text}
					</li>
				))}
			</ul>
		</nav>
	)
}
export default Llegenda
